module.exports = __webpack_public_path__ + "img/MiddleSide_right.b4ab04ad.jpg";